<template>
  <div>
    <el-select
      v-if="this.showIframeBlock"
      v-model="value"
      style="marginRight: 10px"
      class="selectOption"
      placeholder="Last 5 minutes"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select
      v-if="this.showIframeBlock"
      v-model="valueRefresh"
      class="selectOption"
      style="marginRight: 10px"
      placeholder="Refresh iframe 5s"
    >
      <el-option
        v-for="item in timeRefrach"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-button size="medium" class="btnIframe" @click="hideBtn">
      {{ this.showBtn ? "Close graph" : "Open graph" }}
    </el-button>
    <div v-if="this.showIframeBlock">
      <iframe
        v-for="(item, index) in linkFrameMap"
        :key="index"
        :src="item"
        width="100%"
        height="400"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAPI, token } from "@/api/params.js";
export default {
  name: "IframeAdminBar",
  props: {
    serverInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      serverUrl: this.serverInfo.apiUrl,
      grapgInfo: {},
      linkFrameMap: [],
      grafanaToken: [],
      showBtn: true,
      showIframeBlock: true,
      options: [
        {
          value: "now-5m",
          label: "Last 5 minutes"
        },
        {
          value: "now-15m",
          label: "Last 15 minutes"
        },
        {
          value: "now-30m",
          label: "Last 30 minutes"
        },
        {
          value: "now-1h",
          label: "Last 1 hours"
        },
        {
          value: "now-3h",
          label: "Last 3 hours"
        },
        {
          value: "now-6h",
          label: "Last 6 hours"
        },
        {
          value: "now-12h",
          label: "Last 12 hours"
        },
        {
          value: "now-24h",
          label: "Last 24 hours"
        }
      ],
      value: "now-24h",
      timeRefrach: [
        {
          value: "refresh=5s",
          label: "Refresh iframe 5s"
        },
        {
          value: "refresh=10s",
          label: "Refresh iframe 10s"
        },
        {
          value: "refresh=30s",
          label: "Refresh iframe 30s"
        },
        {
          value: "refresh=1m",
          label: "Refresh iframe 1m"
        },
        {
          value: "refresh=5m",
          label: "Refresh iframe 5m"
        },
        {
          value: "refresh=15m",
          label: "Refresh iframe 15m"
        },
        {
          value: "refresh=30m",
          label: "Refresh iframe 30m"
        },
        {
          value: "refresh=1h",
          label: "Refresh iframe 1h"
        }
      ],
      valueRefresh: "refresh=5s"
    };
  },
  computed: {
    ...mapState({
      servers: state => state.admin.servers,
      /** current selected server ID */
      selectedServerId: state => state.admin.currentServerId
    }),
    // @vuese
    // Selected server object
    selectedServer() {
      if (this.selectedServerId == null) {
        /** check that id is set, otherwise return null */
        return null;
      }
      const server = this.servers.find(s => s.id == this.selectedServerId);
      return server;
    },
    valueInstance() {
      return `${this.selectedServer.data.worker_host}:${this.selectedServer.data.worker_port}`;
    },
    linkIframe() {
      return `${this.grapgInfo.base_url}?orgId=1&var-instance=${this.valueInstance}&from=${this.value}&to=now&theme=light&${this.valueRefresh}`;
    },
    linkFrameMapRefresh() {
      return this.grapgInfo.panel_ids.map(
        e => this.linkIframe + `&panelId=${e}`
      );
    }
  },
  watch: {
    value() {
      this.linkFrameMap = this.linkFrameMapRefresh;
    },
    valueRefresh() {
      this.linkFrameMap = this.linkFrameMapRefresh;
    },
    async linkIframe() {
      const token = localStorage.getItem("accessToken");
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      let response = await fetch(`${getAPI()}/admin/grafanaToken`, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
      });
      if (!response.ok) return;
      json = await response.json();
      this.grafanaToken = json.data;
      response = await fetch(`${getAPI()}/admin/graph`, {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
      });

      if (!response.ok) return;
      let json = await response.json();
      this.grapgInfo = json.data;
      this.linkFrameMap = json.data.panel_ids.map(
        e => this.linkIframe + `&panelId=${e}&auth_token=${this.grafanaToken}`
      );
      //old variant
      // console.log("grafanaToken",this.grafanaToken)
      // fetch(`${getAPI()}/admin/graph`).then(async response => {
      //   if (response.ok) {
      //     const json = await response.json();
      //     this.grapgInfo = json.data;
      //     this.linkFrameMap = this.grapgInfo.panel_ids.map(
      //       e => this.linkIframe + `&panelId=${e}`
      //     );
      //   } else {
      //     console.log("Ошибка HTTP: " + response.status);
      //   }
      // });
    }
  },
  mounted() {},
  async created() {
    const token = localStorage.getItem("accessToken");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    let response = await fetch(`${getAPI()}/admin/grafanaToken`, {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    });
    if (!response.ok) return;
    json = await response.json();
    this.grafanaToken = json.data;
    response = await fetch(`${getAPI()}/admin/graph`, {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    });

    if (!response.ok) return;
    let json = await response.json();
    this.grapgInfo = json.data;
    this.linkFrameMap = json.data.panel_ids.map(
      e => this.linkIframe + `&panelId=${e}&auth_token=${this.grafanaToken}`
    );
    const res = await fetch(`${this.linkFrameMap.base_url}`, {
      method: "GET",
      headers: {
        authorization: `Bearer ${this.grafanaToken}`

        // Here you can set any headers you want
      }
    });

    //старое решение
    // const blob = res.blob();
    // const urlObject = URL.createObjectURL(blob);
    // document.querySelector("iframe").setAttribute("src", urlObject);

    // fetch(`${getAPI()}/admin/graph`).then(async response => {
    //   if (response.ok) {
    //     const json = await response.json();
    //     this.grapgInfo = json.data;
    //     this.linkFrameMap = this.grapgInfo.panel_ids.map(
    //       e => this.linkIframe + `&panelId=${e}`
    //     );
    //   } else {
    //     console.log("Ошибка HTTP: " + response.status);
    //   }
    // });
  },
  methods: {
    hideBtn() {
      this.showBtn = !this.showBtn;
      this.showIframeBlock = !this.showIframeBlock;
    }
  }
};
</script>
<style>
.react-grid-layout {
  height: 100%;
}
.btnIframe {
  background: #5d5d5d;
  /* position: absolute; */
  /* right: 36px; */
}
.selectOption {
  /* margin-bottom: 30px; */
}
.el-button:hover,
.el-button:focus {
  background: #5d5d5d;
}
.el-button--medium {
  padding: 12px 30px;
  /* margin-bottom: 30px; */
}
</style>
